import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { strings } from '@/constants/residents/strings';

interface NotificationEmptyStateProps {
  title?: string;
  message?: string;
}

export const NotificationEmptyState: React.FC<NotificationEmptyStateProps> = ({
  title = strings.notifications.mobile.empty.title,
  message = strings.notifications.mobile.empty.message,
}) => {
  const { colors } = useThemeColors();

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <RESIDENTS_SVG_COMPONENTS.NOTIFICATION
          width={68}
          height={68}
          color={colors.text.subtle}
        />
      </View>

      <View style={styles.textContainer}>
        <Text style={[styles.title, { color: colors.text.primary }]}>{title}</Text>
        <Text style={[styles.message, { color: colors.text.dim }]}>{message}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    gap: 18,
  },
  iconContainer: {
    width: 68,
    height: 68,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    alignItems: 'center',
    gap: 6,
    maxWidth: 240,
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.cardTitleLarge,
    textAlign: 'center',
    lineHeight: 24,
  },
  message: {
    ...REDESIGN_TYPOGRAPHY.body,
    textAlign: 'center',
    lineHeight: 21,
  },
});

export default NotificationEmptyState;
